import React, { useState } from "react";
import { Link } from "react-router-dom";
import { InfoCircleOutlined } from "@ant-design/icons";
import CategoryInfo from "../consulting/components/CategoryInfo";

const MenuItem = ({ link = "/", text = "Menu Item", icon, item }) => {
  const [openCatInfo, setOpenCatInfo] = useState(false);

  function openInfo(event, item) {
    event.preventDefault();
    setOpenCatInfo(item);
  }
  return (
    <>
      <Link to={link} className={"menu-item"}>
        <div className={"content"}>
          <div className="icon">{icon && icon}</div>
          {link === "#" ? (
            <div className="text">
              {text}
              <span style={{ color: "red", float: "left", paddingLeft: 49 }}>
                (به زودی)
              </span>
            </div>
          ) : (
            <div className="text">{text}</div>
          )}
          <div
            className="item-info item-info-menu"
            onClick={(event) => openInfo(event, item)}
          >
            <InfoCircleOutlined
              style={{ fontSize: 19, opacity: 0.7, marginTop: 4 }}
            />
          </div>
        </div>
      </Link>
      <CategoryInfo openCatInfo={openCatInfo} setOpenCatInfo={setOpenCatInfo} />
    </>
  );
};

export default MenuItem;
